import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Button from 'components/button/ActionButton';
import Column from 'components/ui/show/Column';
import Header from 'components/ui/general/Header';
import InnerColumn from 'components/ui/show/InnerColumn';
import Section from 'components/ui/general/Section';
import Title from 'components/ui/general/Title';
import { Link } from 'react-router-dom';
import AssignmentTurnedInIcon from 'material-ui/svg-icons/action/assignment-turned-in';
import translate from 'components/hoc/translate';
import theme from 'theme/theme';
import styled from 'styled-components';

const StyledLink = styled(Link)`
    text-decoration: none;
    display: inline-flex;
`;

const NoAccountContainer = (props) => {
    const {
        translate,
    } = props;

    return (
        <div>
            <Header>
                <Title
                    title={ translate('resources.no_account.title') }
                />

                <Actions>
                    <StyledLink
                        to='@me/invitations'
                    >
                        <Button
                            icon={ <AssignmentTurnedInIcon color={ theme.palette.doveGray } /> }
                            title={ translate('resources.invitations.title') }
                        />
                    </StyledLink>
                </Actions>
            </Header>

            <Section>
                <Column>
                    <InnerColumn>
                        { translate('resources.no_account.description') }
                    </InnerColumn>
                </Column>
            </Section>
        </div>
    );
};

NoAccountContainer.propTypes = {
    translate: PropTypes.func.isRequired,
};

export default translate(NoAccountContainer);



// WEBPACK FOOTER //
// ./src/pages/Dashboard/no-account/NoAccountContainer.js